import { makeAutoObservable } from "mobx";
import { persist } from "mobx-persist";

import { RootStore } from "./RootStore";

class DeliveryPinStore {
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  @persist deliveryPin = "";

  @persist expiryDateMs: number | null = null;

  setExpiryDateMs = (ms: number | null): void => {
    this.expiryDateMs = ms;
  };

  setDeliveryPin = (value: string): void => {
    this.deliveryPin = value;
  };
}

export default DeliveryPinStore;
